import { useField } from '@unform/core';
import { ErrorMessage, RadioField, IRadioField } from 'components';
import React, { ComponentProps, memo, useCallback, useEffect, useRef } from 'react';
import * as Styles from './styles';

import { yo } from 'models/CommentedAnswer';

interface IProps extends ComponentProps<typeof RadioField> {
  name: string;
  notErrorMargin?: boolean;
}

const RadioInputComp: React.FC<IProps> = ({ name, onChange, notErrorMargin, hidden, ...props }) => {
  const inputRef = useRef<IRadioField>(null);

  const { fieldName, defaultValue, registerField, error, clearError } = useField(name);

  const handleChange = useCallback(
    (e: yo) => {
      error && clearError();

      onChange?.(e);
    },
    [error, onChange],
  );

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef,
      getValue: ref => {
        const resp = ref.current.value;
        if (resp === true) {
          return 'yes';
        } else if (resp === false) {
          return 'no';
        }
      },
      setValue: (ref, value) => {
        ref.current.value = value;
      },
      clearValue: ref => {
        ref.current.value = 'no';
      },
    });
  }, [fieldName, registerField]);

  return (
    <Styles.Container hidden={hidden}>
      <RadioField
        onChange={handleChange}
        defaultValue={defaultValue}
        inputRef={inputRef}
        isInvalid={!!error}
        isBool
        {...props}
      />

      {notErrorMargin ? (
        error && <ErrorMessage>{error}</ErrorMessage>
      ) : (
        <ErrorMessage>{error}</ErrorMessage>
      )}
    </Styles.Container>
  );
};

export const RadioInput = memo(RadioInputComp);
